<template>
  <div style="height: 100%">
    <el-main style="height: 100%">
      <div class="map" id="map"></div>
      <div style="display: none" class="inforight">
        <infomation
          ref="infomation2"
          id="infomation2"
          :item="infoitem"
          clearable
        ></infomation>
      </div>
    </el-main>
    <machineList
      :Info="this.Info"
      @changeRecycleType="changeRecycle"
      @getMachineInfo="getMachineInfo"
    ></machineList>
  </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import machineList from "./machineList.vue";
import infomation from "./infomation.vue";
import { EventBus } from "./MEventBus.js";
export default {
  // beforeMount() {
  //   this.getMachineInfo();
  // },
  components: {
    machineList,
    infomation,
  },
  data() {
    return {
      // 保留所有设备数据
      mapInfo: "",
      // 查找设备数据结果
      Info: "",
      latlng: {
        lat: 22.4,
        lng: 114.17,
      },
      infoitem: "",
      // 图片列表
      imgList: [
        require("@/assets/mapImg/M1.png"),
        require("@/assets/mapImg/M2.png"),
        require("@/assets/mapImg/M3.png"),
        require("@/assets/mapImg/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      imgList1: [
        require("@/assets/mapImgHK/M1.png"),
        require("@/assets/mapImgHK/M2.png"),
        require("@/assets/mapImgHK/M3.png"),
        require("@/assets/mapImgHK/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      imgList2: [
        require("@/assets/mapImgMINI/M1.png"),
        require("@/assets/mapImgMINI/M2.png"),
        require("@/assets/mapImgMINI/M3.png"),
        require("@/assets/mapImgMINI/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      imgList3: [
        require("@/assets/mapImgOlar/M1.png"),
        require("@/assets/mapImgOlar/M2.png"),
        require("@/assets/mapImgOlar/M3.png"),
        require("@/assets/mapImgOlar/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      imgList4: [
        require("@/assets/mapImgJAMINI/M1.png"),
        require("@/assets/mapImgJAMINI/M2.png"),
        require("@/assets/mapImgJAMINI/M3.png"),
        require("@/assets/mapImgJAMINI/M4.png"),
        // require("@/assets/mapImg/icon_machine_disable.png"),
      ],
      // 回收類型
      MrecycleType: 1,
      // 标记点图层
      markers: null,
      olayer: [],
      project: {},
      urlFile: "",
    };
  },
  mounted() {
    this.getMachineInfo();
    EventBus.$on("infopane", (val) => {
      // A发送来的消息
      this.infopane(val);
    });

    if (process.env.VUE_APP_API_BASE_NAME == "hk") {
      this.urlFile = "HK";
    } else if (process.env.VUE_APP_API_BASE_NAME == "ja") {
      this.urlFile = "ja";
      if (localStorage.getItem("project") == "17") {
        this.urlFile = "JAMINI";
      }
    } else if (process.env.VUE_APP_API_BASE_NAME == "mini") {
      this.urlFile = "MINI";
    } else if (process.env.VUE_APP_API_BASE_NAME == "olar") {
      this.urlFile = "Olar";
    }
  },
  methods: {
    // 地图
    initMap() {
      if (!this.map) {
        //1、定义图层样式// http://{s}.tile.osm.org/{z}/{x}/{y}.png

        var layer = L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="OpenStreetMaphttps://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        });
        //2、创建地图
        // layer.options.maxZoom = 25;
        // layer.options.maxNativeZoom = 20;
        // var corner1 = L.latLng(22.584205677758984, 114.18296813964845); //设置左上角經緯度
        // var corner2 = L.latLng(22.124913430063163, 114.16511535644533);
        // var corner3 = L.latLng(22.325210908151757, 113.7023162841797);
        // var corner4 = L.latLng(22.290215364587667, 114.50247555971148);
        // var bounds = L.latLngBounds(corner1, corner2, corner3, corner4);
        let map = L.map("map", {
          center:
            this.project.latLng.lat && this.project.latLng.lng
              ? this.project.latLng
              : this.latlng, //中心坐标
          zoom: this.project.zoom || 11, //缩放级别
          minZoom: this.project.zoom || 11,
          // maxZoom: 19,
          zoomControl: false, //缩放组件
          attributionControl: false, //去掉右下角logol
          layers: [layer], //图层
        });
        this.map = map;
        // map.fitBounds(bounds);
        setTimeout(() => this.map.invalidateSize(true), 10);
        //3、点击事件
        this.map.on("click", (i) => {
          // 点击获取地图上的經緯度

          this.latlng = i.latlng;
          this.map.setView(this.latlng);
        });
      }
      this.addMakerToMap();
    },
    getProjectList() {
      this.$http.project.getProject().then((res) => {
        if (res.code == 200 && res.datas) {
          res.datas.forEach((item) => {
            if (localStorage.getItem("project") == item.id) {
              this.project.latLng = {};
              this.project.zoom = item.zoom;
              if (item.latLng) {
                this.project.latLng.lat = item.latLng.split(",")[0];
                this.project.latLng.lng = item.latLng.split(",")[1];
              }
              this.project.districtId = item.districtId;
            }
          });
          this.initMap();
        }
      });
    },
    // 添加标记点
    addMakerToMap() {
      if (this.olayer.length > 0) {
        this.olayer = [];
        this.markers.clearLayers();
        // return;
      }
      this.markers = L.layerGroup();
      // this.markers.options.layerId = 10212566;
      // 定义标记点图标
      var icon1 = new L.Icon({
        className: "lmap-icon",
        iconUrl:
          this.urlFile == "ja"
            ? this.imgList[0]
            : this.urlFile == "HK"
            ? this.imgList1[0]
            : this.urlFile == "Olar"
            ? this.imgList3[0]
            : this.urlFile == "JAMINI"
            ? this.imgList4[0]
            : this.imgList2[0],
        iconSize: [25, 40],
        iconAnchor: [24, 32],
      });
      var icon2 = new L.Icon({
        className: "lmap-icon",
        iconUrl:
          this.urlFile == "ja"
            ? this.imgList[1]
            : this.urlFile == "HK"
            ? this.imgList1[1]
            : this.urlFile == "Olar"
            ? this.imgList3[1]
            : this.urlFile == "JAMINI"
            ? this.imgList4[1]
            : this.imgList2[1],
        iconSize: [25, 40],
        iconAnchor: [24, 32],
      });
      var icon3 = new L.Icon({
        className: "lmap-icon",
        iconUrl:
          this.urlFile == "ja"
            ? this.imgList[2]
            : this.urlFile == "HK"
            ? this.imgList1[2]
            : this.urlFile == "Olar"
            ? this.imgList3[2]
            : this.urlFile == "JAMINI"
            ? this.imgList4[2]
            : this.imgList2[2],
        iconSize: [25, 40],
        iconAnchor: [24, 32],
      });
      var icon4 = new L.Icon({
        className: "lmap-icon",
        iconUrl:
          this.urlFile == "ja"
            ? this.imgList[3]
            : this.urlFile == "HK"
            ? this.imgList1[3]
            : this.urlFile == "Olar"
            ? this.imgList3[3]
            : this.urlFile == "JAMINI"
            ? this.imgList4[3]
            : this.imgList2[3],
        iconSize: [25, 40],
        iconAnchor: [24, 32],
      });
      this.Info.forEach((item) => {
        var marker2 = "";
        if (item.platLng) {
          if (item.online) {
            item.overflows.forEach((item2) => {
              if (item2.rid == this.MrecycleType) {
                if (item2.overflow < 70) {
                  marker2 = L.marker(item.platLng, {
                    icon: icon1,
                    riseOnHover: true,
                  });
                } else if (item2.overflow >= 70 && item2.overflow <= 90) {
                  marker2 = L.marker(item.platLng, {
                    icon: icon2,
                    riseOnHover: true,
                  });
                } else if (item2.overflow >= 90 && item2.overflow <= 100) {
                  marker2 = L.marker(item.platLng, {
                    icon: icon3,
                    riseOnHover: true,
                  });
                }
              }
            });
          } else {
            marker2 = L.marker(item.platLng, {
              icon: icon4,
              riseOnHover: true,
            });
          }
        }
        if (marker2) {
          this.olayer.push(marker2);
          this.markers.addLayer(marker2);
          marker2.on("click", () => {
            this.infopane(item);
          });
        }

        this.markers.addTo(this.map);
      });
    },
    // 标记点信息
    infopane(item) {
      this.infoitem = [];
      var dom = this.$refs.infomation2.$el;
      this.infoitem = item;
      if (this.infoitem.online) {
        this.infoitem.overflows.forEach((item2) => {
          if (item2.rid == this.MrecycleType) {
            this.infoitem.image = item2.image;
            this.infoitem.imageC = item2.imageC;
          }
        });
      } else if (!this.infoitem.online) {
        this.infoitem.image = item.image;
        this.infoitem.imageC = item.imageC;
      }
      new L.popup({
        // 是否自动调整窗体到视野内（当信息窗体超出视野范围时，通过该属性设置是否自动平移地图，使信息窗体完全显示）
        autoPaning: true,
        keepInView: true,
        // 开启keepInView，在切后台时可能会导致一直触发autupandstart事件，建议关闭
        // keepInView: true,
        // 弹出位置偏移量，可根据标记点图标大小修
        offset: new L.point(-15, -26),
        autoClose: true,
      })
        .setLatLng(item.platLng)
        .setContent(dom)
        .openOn(this.map);
      this.map.panTo(item.platLng);
      return;
    },
    // 地图信息
    // 获得所有設備信息
    async getMachineInfo(params) {
      this.mapInfo = [];
      let res = await this.$http.map.getMachineInfo(params);
      this.getProjectList();

      this.mapInfo = res;
      this.mapInfo.forEach((item) => {
        // let params = {}
        if (item.platLng != null && item.platLng != "") {
          let ling = item.platLng.replace(/，/g, ",");
          let itemlatLng = ling.split(",");
          let params = {};
          params.lng = Number(itemlatLng[1]);
          params.lat = Number(itemlatLng[0]);
          item.platLng = params;
        }
        if (item.overflows) {
          item.overflows.forEach((item2) => {
            if (item2.overflow < 70) {
              (item2.image =
                this.urlFile == "ja"
                  ? this.imgList[0]
                  : this.urlFile == "HK"
                  ? this.imgList1[0]
                  : this.urlFile == "Olar"
                  ? this.imgList3[0]
                  : this.urlFile == "JAMINI"
                  ? this.imgList4[0]
                  : this.imgList2[0]),
                (item2.imageC = this.$t("map.machineState.MoreSpace"));
            } else if (item2.overflow >= 70 && item2.overflow <= 90) {
              (item2.image =
                this.urlFile == "ja"
                  ? this.imgList[1]
                  : this.urlFile == "HK"
                  ? this.imgList1[1]
                  : this.urlFile == "Olar"
                  ? this.imgList3[1]
                  : this.urlFile == "JAMINI"
                  ? this.imgList4[1]
                  : this.imgList2[1]),
                (item2.imageC = this.$t("map.machineState.ProvideService"));
            } else if (item2.overflow >= 90 && item2.overflow <= 100) {
              (item2.image =
                this.urlFile == "ja"
                  ? this.imgList[2]
                  : this.urlFile == "HK"
                  ? this.imgList1[2]
                  : this.urlFile == "Olar"
                  ? this.imgList3[2]
                  : this.urlFile == "JAMINI"
                  ? this.imgList4[2]
                  : this.imgList2[2]),
                (item2.imageC = this.$t("map.machineState.NearlyOverflow"));
            }
          });
        }
        if (!item.online) {
          item.image =
            this.urlFile == "ja"
              ? this.imgList[3]
              : this.urlFile == "HK"
              ? this.imgList1[3]
              : this.urlFile == "Olar"
              ? this.imgList3[3]
              : this.urlFile == "JAMINI"
              ? this.imgList4[3]
              : this.imgList2[3];

          item.imageC = this.$t("map.machineState.outOfService");
        }
      });
      this.Info = this.mapInfo;
    },
    // 修改回收類型
    changeRecycle(val) {
      let arr = [];
      this.MrecycleType = val;
      this.mapInfo.forEach((item1) => {
        if (item1.overflows) {
          item1.overflows.forEach((item2) => {
            if (item2.rid == val) {
              arr.push(item1);
            }
          });
        }
      });

      this.Info = arr;
      this.addMakerToMap();
    },
  },
  beforeDestroy() {
    this.map.off();
    this.map.remove();
  },
};
</script>

<style scoped>
/deep/.leaflet-pane .leaflet-tile-pane {
  filter: contrast(55%) saturate(95%) brightness(125%) !important;
}
/deep/.el-main {
  height: 100%;
  padding: 0;
  overflow: hidden;
}
.map {
  width: 100%;
  height: 88vh;
  z-index: 1;
  margin-left: 20px;
  overflow: hidden;
}
/deep/.leaflet-popup-content {
  width: 390px !important;
  margin-left: 5px;
  margin-right: 5px;
}
</style>
